import { styled } from '@storybook/theming';
import ChatIcon from 'assets/img/chat';
import CheckIcon from 'assets/img/check.svg';
import ArrowIcon from 'assets/img/right-arrow.svg';
import classnames from 'classnames';
import getTGBackgroundColor from 'components/common/getTGBackgroundColor';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import {
  getFullyQualifiedKategori,
  getIsCritical,
  getSubCategory,
  getTgValue,
  getSjekkpunkWorseTGDescribedInText,
} from 'store/tilstandsrapportEntities/sjekkpunkter/selectors';
import { Tag } from 'store/tilstandsrapportEntities/sjekkpunkter/types';
import { getSjekkpunktIsRead } from 'store/user/read/selectors';
import ItemContainer from './ItemContainer';
import styles from './styles.scss';
import TgMismatchIndicator from './TgMismatchIndicator';

interface Props {
  tilstandsrapportId: string;
  id: string;
  className?: string;
  chat?: any;
}

interface StateProps {
  isRead: boolean;
  tg: number;
  kategori: string;
  underkategori: string;
  isCritical: boolean;
  worseTGDescribedInText: Tag;
}

const tgLabel = {
  '-1': 'TGIU',
  '0': 'TG0',
  '1': 'TG1',
  '2': 'TG2',
  '3': 'TG3',
};

const Item = ({
  tilstandsrapportId,
  id,
  isRead,
  isCritical,
  tg,
  kategori,
  underkategori,
  className,
  worseTGDescribedInText,
  chat,
}: Props & StateProps): JSX.Element => {
  // data-* used for tracking purposes.

  const qa = chat?.qas.find(q => (q.sjekkpunktId === id));

  return (
    <li
      className={classnames(styles.item, isCritical && tg !== -1 && styles.critical, className && className)}
      data-tg={tg}
      data-read={isRead}
      data-critical={isCritical}
    >
      <ItemContainer
        tilstandsrapportId={tilstandsrapportId}
        id={id}
        chat={chat}
        className={classnames(styles.link, isCritical && tg !== -1 && getTGBackgroundColor(tg))}
      >
        <>
          <div
            className={classnames(
              styles.tgBox,
              isCritical && tg !== -1 ? getTGBackgroundColor(tg, 'darker') : getTGBackgroundColor(tg),
            )}
          >
            <div className={styles.tgValue}>
              <span>{tgLabel[tg]}</span>
            </div>
            {worseTGDescribedInText && (
              <TgMismatchIndicator className={styles.tgMismatch} mismatchNum={worseTGDescribedInText.tag} />
            )}
          </div>
          <div className={styles.categorySubcategoryBox}>
            <h3 className={styles.category}>{kategori}</h3>
            <h4 className={styles.subCategory}>{underkategori}</h4>
          </div>
          {
            qa && (
              <div className={classnames(styles.chat, tg === -1 && styles.withPadding)}>
                <ChatIcon color={tg === -1 ? "#143268" : null} />
              </div>
            )
          }
          {/* Do not show arrow / checked if TG IU */}
          {tg !== -1 && (
            <div className={classnames(styles.arrow, isRead && styles.isRead)}>
              <div>{isRead ? <CheckIcon /> : <ArrowIcon />}</div>
            </div>
          )}
        </>
      </ItemContainer>
    </li>
  );
};

const mapStateToProps = (state: AppState, { id, tilstandsrapportId }): StateProps => ({
  isRead: getSjekkpunktIsRead(state, id),
  tg: getTgValue(state, id),
  isCritical: getIsCritical(state, id),
  kategori: getFullyQualifiedKategori(state, id),
  underkategori: getSubCategory(state, id, tilstandsrapportId),
  worseTGDescribedInText: getSjekkpunkWorseTGDescribedInText(state, id),
});

export default connect(
  mapStateToProps,
  {},
)(Item);
